module.exports = __webpack_public_path__ + "static/media/achievement-badge-attachment-explorer-journeyman.a043a6a5.svg";